import PageTicketCategories from "@/systems/modules/support/PageTicketCategories.vue";
import authorization from "@/authorization";
import SupportHeaderView from "@/systems/modules/support/SupportHeaderView.vue";
import TicketsView from "@/systems/modules/support/TicketsView.vue";
import SupportBansView from "@/systems/modules/support/SupportBansView.vue";
import PlayerTicketsView from "@/systems/modules/support/PlayerTicketsView.vue";
import {modules} from "@/systems/modules/modules";

export default {
    initialize() {

    },
    getRoutes: () => ([
        {
            name: "community.modules.support",
            path: "support",
            component: SupportHeaderView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.support) && (authorization.permission("modules.support.tickets.categories.edit") || authorization.permission("modules.support.tickets.answer")),
            },
            redirect: { name: "community.modules.support.tickets" },
            children: [
                {
                    name: "community.modules.support.tickets",
                    path: "tickets",
                    component: TicketsView,
                    props: route => ({ communityId: route.params.communityId, categoryId: route.query.categoryId }),
                },
                {
                    name: "community.modules.support.tickets.categories",
                    path: "tickets/categories",
                    component: PageTicketCategories,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.support.tickets.categories.edit")
                    }
                },
                {
                    name: "community.modules.support.bans",
                    path: "bans",
                    component: SupportBansView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.support.bans.edit")
                    }
                }
            ]
        }
    ]),
    getPlayerRoutes: () => [
        {
            name: "player.modules.support",
            path: "support/tickets",
            component: PlayerTicketsView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.support) && (authorization.permission("modules.support.tickets.categories.edit") || authorization.permission("modules.support.tickets.answer")),
            }
        },
    ]
};